<template>
  <v-app>
    <v-main class="pa-0">
      <v-container class="pa-0 mr-0 ml-0">
        <v-row>
          <v-col cols="12">
            <v-card
              elevation="0"
              class="rounded-lg mt-5 primary--text"
              color="#f5f5f5"
            >
              <v-row>
                <v-col cols="2">
                  <div class="text-start ps-5">
                    {{ $t("reports.course.courseName") }}
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="text-start">
                    {{ $t("user.registration.organization") }}
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="text-center">
                    {{ $t("statistics.totalEnrolments") }}
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="text-center">
                    {{ $t("reports.revenues.totalAmount") }}
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="text-center">
                    {{ $t("user.registration.discount") }}
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="text-center pe-5">
                    {{ $t("user.registration.invoiceAmount") }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" v-for="n in 20" :key="n">
                <!-- <div v-if="n === 12" class="html2pdf__page-break" /> -->
                <revenue-report-card-pdf-content :revenueData="{}" />
              </v-col>
            </v-row>
            <!-- <v-row v-if="contents.length">
              <v-col cols="12" v-for="(data, index) in contents" :key="index">
                <course-report-card-pdf-content :courseData="data" />
              </v-col>
            </v-row>
            <v-row
              v-else-if="!contents.length"
              class="textLight--text font-weight-medium"
              align="center"
            >
              <v-col cols="12">
                {{ $t("noItems") }}
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import RevenueReportCardPdfContent from "./RevenueReportCardPdfContent.vue";
export default {
  components: {
    RevenueReportCardPdfContent,
  },
  props: {
    contents: {
      type: Array,
    },
  },
};
</script>
